import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import es from './es.json';


i18n.use(initReactI18next)
  .init({
    compatibilityJSON: 'v3',
    fallbackLng: 'es',
    supportedLngs: ['es'],
    resources: {
      es: es,
    },
    detection: {
      caches: []
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;